'use strict';

const MailingController = [
  '$stateParams',
  'mailing',

  function ($stateParams, mailing) {
    mailing.handleRedirect($stateParams);
  }
];

export default MailingController;



// WEBPACK FOOTER //
// ./app/src/modules/mailing/mailing.controller.js